import React from "react";

import classes from "./Spinner.module.css";

const spinner = () => <div className={classes.Hourglass}>Loading...</div>;

export default spinner;
